import * as React from 'react';

import {IconTab} from './icon-tab';

import styles from './icon-tabs.module.css';

export type Tab = {
    Icon: React.ComponentType<any> | string;
    label: string | null | undefined | React.ReactNode;
    isActive: boolean;
    id: string;
    href?: string;
    onClick?: () => void;
    size?: number;
};

type Props = {
    tabs: Tab[];
};

export function IconTabs(props: Props) {
    return (
        <div className={styles['view-picker']}>
            {props.tabs.map((tab) => {
                return <IconTab key={tab.id} {...tab} />;
            })}
        </div>
    );
}
